module.exports = __webpack_public_path__ + "static/img/kugua.070d7de9.png";